module.exports = __webpack_public_path__ + "assets/img/map.de1b24fe.png";